import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

const CADashboardLayout = () => {
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname.split('/').pop();
    switch (path) {
      case 'overview': return 'Dashboard Overview';
      case 'sales-report': return 'Sales Report';
      case 'commission-report': return 'Commission Report';
      case 'user-financials': return 'User Financials';
      case 'all-orders': return 'All Orders Report';
      default: return 'CA Dashboard';
    }
  };

  return (
    <div className="ca-dashboard-layout">
      <Sidebar />
      <div className="main-content">
        <header className="main-header">
          <h1>{getPageTitle()}</h1>
        </header>
        <main className="content-area">
          <Outlet />
        </main>
      </div>
      <style jsx>{`
        .ca-dashboard-layout {
          display: flex;
          background: #f1f5f9;
          min-height: 100vh;
        }
        
        .main-content {
          margin-left: 220px;
          width: calc(100% - 220px);
          min-height: 100vh;
        }
        
        .main-header {
          background: white;
          padding: 16px 24px;
          border-bottom: 1px solid #e2e8f0;
          position: sticky;
          top: 0;
          z-index: 50;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        }
        
        .main-header h1 {
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0;
          color: #1e293b;
        }
        
        .content-area {
          padding: 20px;
        }

        @media (max-width: 768px) {
          .main-content {
            margin-left: 0;
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default CADashboardLayout;
